import { render, staticRenderFns } from "./UnassignedReservation.vue?vue&type=template&id=f35cdcd4&scoped=true"
import script from "./UnassignedReservation.vue?vue&type=script&lang=js"
export * from "./UnassignedReservation.vue?vue&type=script&lang=js"
import style0 from "./UnassignedReservation.vue?vue&type=style&index=0&id=f35cdcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35cdcd4",
  null
  
)

export default component.exports